import React from 'react';
import { trackChatSoftGateHit, trackUpgradeCtaClicked } from '../../hooks/useAnalytics';
import './ChatSoftGate.css';

interface ChatSoftGateProps {
  gateType: 'signup' | 'upgrade' | '';
  onUpgrade: () => void;
  onDismiss: () => void;
  /**
   * Fire `chat_soft_gate_hit` on mount (the default). A parent that counts
   * gate activations itself passes `false`, so one activation is counted in
   * exactly one place however often the card mounts within it.
   */
  trackHit?: boolean;
}

const ChatSoftGate: React.FC<ChatSoftGateProps> = ({ gateType, onUpgrade, onDismiss, trackHit = true }) => {
  const isUpgrade = gateType === 'upgrade';

  React.useEffect(() => {
    if (trackHit) trackChatSoftGateHit(0);
    // Mount-only, as before: the prop decides whether this mount counts.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUpgrade = () => {
    trackUpgradeCtaClicked(isUpgrade ? 'chat_soft_gate_upgrade' : 'chat_soft_gate_signup');
    onUpgrade();
  };

  return (
    <div className="chat-soft-gate">
      <div className="chat-soft-gate-icon">
        {isUpgrade ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        )}
      </div>
      <div className="chat-soft-gate-content">
        <p className="chat-soft-gate-title">
          {isUpgrade
            ? 'Unlock VizDay Plus'
            : 'Create a free account to keep planning'}
        </p>
        <p className="chat-soft-gate-body">
          {isUpgrade
            ? 'Upgrade to Plus for smarter plans, deeper personalization, and unlimited AI messages.'
            : 'Sign up to save your plans, browse the community, and continue planning with AI.'}
        </p>
      </div>
      <div className="chat-soft-gate-actions">
        <button className="chat-soft-gate-cta" onClick={handleUpgrade}>
          {isUpgrade ? 'Upgrade to Plus — $4.99/mo' : 'Sign up free'}
        </button>
        <button className="chat-soft-gate-dismiss" onClick={onDismiss}>
          Maybe later
        </button>
      </div>
    </div>
  );
};

export default ChatSoftGate;
